/* eslint-disable @typescript-eslint/no-explicit-any */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Enviroment } from './environment.interface';

const isBrowser = typeof window !== 'undefined';

const env = isBrowser ? (window as any).env || {} : process.env;

export const environment: Enviroment = {
	production: (env.PRODUCTION === 'true') as boolean,
	apiUrl: env.API_URL as string,
	erpApiUrl: env.ERP_API_URL as string,
	googleAnalyticsToken: env.GOOGLE_ANALYTICS_TOKEN as string,
	googleTagManagerToken: env.GOOGLE_TAG_MANAGER_TOKEN as string,
	pixelId: env.PIXEL_ID as string,
	facebookAppId: env.FACEBOOK_APP_ID as string,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
